import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableAlternativeRatesRateShopperRecommendations = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableAlternativeRatesRateShopperRecommendations);
};
